export const selectCreditBalance = (state) => state.credit?.balance;
export const selectCreditPeriodStart = (state) => state.credit?.periodStart;
export const selectDaysUntilReset = (state) => state.credit?.daysUntilReset;
export const selectMaxCredits = (state) => state.credit?.maxCredits ?? 3;
export const selectCreditLoading = (state) => state.credit?.isLoading ?? false;
export const selectCreditError = (state) => state.credit?.error;
export const selectHasCredits = (state) => (state.credit?.balance ?? 0) > 0;
export const selectPendingOperations = (state) => state.credit?.pendingOperations ?? 0;
